/**
 * Part of starter project.
 *
 * @copyright  Copyright (C) 2021 __ORGANIZATION__.
 * @license    __LICENSE__
 */

export const Home = {};

import '@main';

await u.domready();

const bannerSwiper = new Swiper(".j-banner-swiper", {
  slidesPerView: 1,
  spaceBetween: 40,
  autoplay: true,
  loop: true,
  centeredSlides: true,
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
  }
});

const podcastSwiper = new Swiper(".j-podcast-swiper", {
  slidesPerView: 1,
  spaceBetween: 30,
  navigation: {
    nextEl: ".j-podcast-swiper-button-next",
    prevEl: ".j-podcast-swiper-button-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    1200: {
      slidesPerView: 3,
    },
  }
});


const articleSwiper = new Swiper(".j-article-swiper", {
  slidesPerView: 1,
  spaceBetween: 30,
  navigation: {
    nextEl: ".j-article-swiper-button-next",
    prevEl: ".j-article-swiper-button-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    1200: {
      slidesPerView: 3,
    },
  }
});

const bookSwiper = new Swiper(".j-book-swiper", {
  slidesPerView: 1,
  spaceBetween: 30,
  navigation: {
    nextEl: ".j-book-swiper-button-next",
    prevEl: ".j-book-swiper-button-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    1200: {
      slidesPerView: 3,
    },
  }
});
